module.exports = __webpack_public_path__ + "static/media/icon_calender_arrow_right.612d1f84.svg";